import { DeliveryVisitGeneratedEntity } from "./generated/DeliveryVisitGeneratedEntity";

export abstract class DeliveryVisitEntity extends DeliveryVisitGeneratedEntity {
    // Comment to preserve new line
}
